import o from"styled-components";const t=o.div`
	position: relative;
	border-radius: ${({borderRadius:o})=>`${o}px`};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	overflow: hidden;
	background-color: ${({backgroundColor:o})=>o};
	border: 0.71px solid ${({theme:o})=>o.border.black10};
	padding: 14px;
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	box-sizing: border-box;
	gap: 14px;
	height: 100%;
`,i=o.h1`
	margin: 0;
	font-size: 18px;
	font-weight: 500;
	color: ${({color:o})=>o};
	padding-top: 7px;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,r=o.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`,p=o.div`
	display: flex;
	gap: 12px;
	align-items: start;

	padding-right: ${({hasLabel:o})=>o?"0":"24px"};

	svg {
		fill: ${({color:o})=>o};

		path {
			fill: ${({color:o})=>o};
		}
	}

	${({hideIcon:o})=>o?"\n\t\t\t\t& > div:first-child {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t":""}
`,e=o.p`
	margin: 0;
	color: ${({color:o})=>o};
	opacity: 0.6;
	font-size: 14px;
	line-height: 18px;
	white-space: pre-wrap;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,n=o.span`
	padding: 5px 10px;
	font-size: 12px;
	color: ${({color:o})=>o};
	background: ${({background:o})=>o};
	border-radius: 9999px;
	max-width: 80%;
	width: fit-content;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,d=o.div`
	position: absolute;
	bottom: 5px;
	right: 10px;
	opacity: 0.5;

	${({arrowOnTop:o=!1})=>o?"\n    bottom: 10px;\n    right: 10px;\n  ":"\n    top: 20px;\n    right: 10px;\n  "}
`,a=o.div`
	font-size: 28px;
	cursor: pointer;
`;export{d as CardArrowContainer,t as CardContainer,r as CardContent,a as CardEmoji,p as CardHeader,i as CardHeading,n as CardLabel,e as CardParagraph};
